/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author Soongjin Park
 * @contact sjpark@detech.co.kr
 * @date 2022-09-01
 * @brief EHP 사업장 관리 개발
 *
 ********************************************************************/
import React, { useState } from "react";
import clog from "../../../utils/logUtils";
/**
 * @brief EHP 사업장 관리 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
//component
import SiteTree from "./SiteTree";
import MngtSite from "./MngtSite";
import MngtZone from "./zone/MngtZone";
function SiteMain(props) {
    //
    const [isMobile, setIsMobile] = useState(false);
    const [adminType, setAdminType] = useState("COMPANY"); // COMPANY, ZONE
    // LIST, CREATE, UPDATE, DELETE, READ, BATCH
    const [workMode, setWorkMode] = useState("READ");
    const defaultTree = () => (setSelTree({
        company: { companyId: "", companyName: "" },
        reload: false
    }));
    const [selTree, setSelTree] = useState({
        company: { companyId: "", companyName: "" },
        reload: false
    });
    function handleSelTree(adminType, treeInfo) {
        clog("IN SITETREE : handleCurTree : " + adminType);
        setAdminType(adminType);
        setSelTree(treeInfo);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(SiteTree, { selTree: selTree, setSelTree: handleSelTree, workMode: workMode, setWorkMode: setWorkMode, adminType: adminType, setAdminType: setAdminType }),
        (adminType === "COMPANY") && React.createElement(MngtSite, { isMobile: isMobile, setIsMobile: setIsMobile, selTree: selTree, setSelTree: handleSelTree, workMode: workMode, setWorkMode: setWorkMode, setPopWin: props.setPopWin }),
        (adminType === "ZONE") && React.createElement(MngtZone, { isMobile: isMobile, setIsMobile: setIsMobile, selTree: selTree, setSelTree: handleSelTree, workMode: workMode, setWorkMode: setWorkMode, setPopWin: props.setPopWin })));
}
export default SiteMain;
